import { Lock } from "@mui/icons-material"
import { Stack, Typography } from "@mui/material"
import { useContext } from "react";
import Parser from "react-html-parser";
import { ConfigurationContext } from "../App";

export const LoginFooter = () => {
  const [config] = useContext(ConfigurationContext);

  return (
    <Stack direction="row" spacing={2}>
      <Lock htmlColor='#999999' />

      <Typography>
        {config?.bottomPageInfo && Parser(config?.bottomPageInfo)}
      </Typography>
    </Stack>
  )
}
